// Map view — no content panel. Cluster markers render as map overlays
// via MapOverlays inside the MapBackground's Map component.
export function MapView() {
    return null;
}
